import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
    name: "LeaveDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_EXIST,
            isLoading: false,
            leaveData: {}
        };
    },

    methods: {
        getLeaveById() {
            axios.get('leave/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data != undefined) {
                        this.leaveData = response.data;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },
        showList() {
            this.$router.push({
                path: "/leave/list"
            });
        },
    },
    mounted() {
        this.isLoading = true;
        this.getLeaveById();
    },
};
